import axiosInstance from "../../../shared/api/axiosInstance";
import { CREATE_ADVERTISMENT_DATA, EDIT_ADVERTISMENT_DATA } from "../../../shared/api/endpoints";
import { configReq } from "../../../shared/lib/functions";
export function saveAdvertisementData({ id, advertisementId, fieldId, value }, token, editing) {
  const payload = { advertisementId, fieldId, value };
  return editing ? axiosInstance.put(EDIT_ADVERTISMENT_DATA, { id, ...payload }, configReq(token))
    : axiosInstance.post(CREATE_ADVERTISMENT_DATA, payload, configReq(token));
}
